import './style.css';
import { use, useEffect, useState } from 'react';
import { scrollChatToBottom } from '~/helpers/action';
import { useConversation } from '~/helpers/store';
export default function TextChat ({ submitMessage=(data, cb=()=>{})=>{}, isChatSubmit }){
    const [ text, setText ] = useState("");
    const convoState = useConversation((state) => state);
    const submit = () => {
        submitMessage(text);
        clearText();
    }
    const clearText = () => {
        setText("");
        scrollChatToBottom();
    };

    return (
        <div className="text-input-container">
            <div>
            <input type="text" placeholder="Ask questions.."
            value={text} onChange={event => setText(event.target.value)}
            onKeyDown={(e) => {
                if( e.keyCode === 13 && !(isChatSubmit || convoState.isStreaming) ) {
                    submit(); // Enter
                }
            }} disabled={(isChatSubmit || convoState.isStreaming)}></input>
            <button onClick={submit} disabled={(isChatSubmit || convoState.isStreaming)}>
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5808 0.415334L1.09 7.60283C0.798005 7.74209 0.806989 8.15987 1.10347 8.29014L5.56422 10.8103C5.82925 10.9585 6.15718 10.9271 6.38629 10.7294L15.182 3.14658C15.2404 3.09717 15.3796 3.00283 15.4336 3.05674C15.492 3.11514 15.4021 3.2499 15.3527 3.3083L7.74293 11.8794C7.53179 12.1175 7.50035 12.4679 7.67105 12.7374L10.5865 17.4138C10.7302 17.6968 11.139 17.6923 11.2693 17.4048L18.0884 0.913967C18.2367 0.59053 17.8998 0.2626 17.5808 0.415334Z" fill="#F5F5F5"/>
                </svg>
            </button>
            </div>
        </div>
    );
}